import { generateTypes } from '@evmos/eip712';
import { TxContext, TxPayload, createTransactionPayload } from '@evmos/transactions';
import { EIP712TypedData } from '@evmos/transactions/dist/messages/base';
import { MsgRemoveApp } from '../ts-client/tx';
import { MsgRemoveApp as MsgRemoveAppProto } from '../proto/tx_pb';

const MSG_REMOVE_APP_TYPES = {
  MsgValue: [
    { name: 'creator', type: 'string' },
    { name: 'id', type: 'uint64' },
    { name: 'rollapp_id', type: 'string' },
  ],
};

export const createTxMsgRemoveApp = (context: TxContext, params: MsgRemoveApp): TxPayload => {
  const typedData = createEIP712MsgRemoveApp(context, params);
  const cosmosMsg = createCosmosMsgRemoveApp(context, params);
  return createTransactionPayload(context, typedData, cosmosMsg);
};

const createEIP712MsgRemoveApp = (context: TxContext, params: MsgRemoveApp): EIP712TypedData => {
  const types = generateTypes(MSG_REMOVE_APP_TYPES);
  const message = createMsgRemoveApp(params);
  return { types, message };
};

const createCosmosMsgRemoveApp = (context: TxContext, params: MsgRemoveApp): any => {
  const message = new MsgRemoveAppProto({
    creator: params.creator,
    id: BigInt(params.id),
    rollappId: params.rollappId,
  });
  return { message, path: MsgRemoveAppProto.typeName };
};

function createMsgRemoveApp(params: MsgRemoveApp): object | object[] {
  return {
    type: 'rollapp/RemoveApp',
    value: {
      creator: params.creator,
      id: params.id,
      rollapp_id: params.rollappId,
    },
  };
}
